// Authentik configuration
const AUTHENTIK_URL = process.env.REACT_APP_AUTHENTIK_URL || 'https://authentik.wla.app';
const CLIENT_ID = process.env.REACT_APP_AUTHENTIK_CLIENT_ID || '';

export const authentikConfig = {
  // Base URLs
  authentikUrl: AUTHENTIK_URL,
  clientId: CLIENT_ID,
  redirectUri: process.env.REACT_APP_REDIRECT_URI || window.location.origin + '/callback',

  // OAuth endpoints
  authorizationEndpoint: `${AUTHENTIK_URL}/application/o/authorize/`,
  tokenEndpoint: `${AUTHENTIK_URL}/application/o/token/`,
  userInfoEndpoint: `${AUTHENTIK_URL}/application/o/userinfo/`,
  endSessionEndpoint: `${AUTHENTIK_URL}/application/o/${process.env.REACT_APP_AUTHENTIK_APP_SLUG || 'airforschen-portal'}/end-session/`,
  enrollmentEndpoint: `${AUTHENTIK_URL}/if/flow/default-enrollment-flow/`,

  // OAuth settings
  scopes: ['openid', 'profile', 'email', 'offline_access'],
  responseType: 'code',
};
